import React from "react";
import { UEListData } from "@/app/interface/homepage";
import CorrectSign from "@/app/assets/icons/correct-sign";

interface StrengthsAndWeaknessProps {
    filteredData: UEListData;
}

const StrengthsAndWeakness: React.FC<StrengthsAndWeaknessProps> = ({ filteredData }) => {
    const hasStrengths = filteredData?.strengths?.length > 0;
    const hasWeaknesses = filteredData?.weaknesses?.length > 0;

    if (!hasStrengths && !hasWeaknesses) {
        return (
            <p className="text-sm italic text-gray-500">No Strengths or Weaknesses identified</p>
        );
    }
    return (
        <div className="mt-6 w-full max-w-[812px]">
            <h2 className="mb-6 text-xl sm:text-3xl font-semibold">Strengths & Weaknesses</h2>
            <div className="space-y-8">
                {hasStrengths && (
                    <div>
                        <h3 className="mb-4 text-lg font-semibold">Strengths</h3>
                        <ul className="space-y-4">
                            {filteredData.strengths.map((item, index) => (
                                <li key={index} className="flex items-start space-x-2">
                                    {/* <span className="text-green-500 font-bold">✔</span> */}
                                    <CorrectSign
                                        className="h-5 w-5 flex-shrink-0 relative top-1"
                                        onClick={() =>
                                            (window.location.href =
                                                process.env.ICM_PLAYSTORE_URL || "")
                                        }
                                    />
                                    <p className="text-sm leading-relaxed text-gray-700">{item}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
                {hasWeaknesses && (
                    <div>
                        <h3 className="mb-4 text-lg font-semibold">Weaknesses</h3>
                        <ul className="space-y-4">
                            {filteredData.weaknesses.map((item, index) => (
                                <li key={index} className="flex items-start space-x-2">
                                    <span className="font-bold text-lg text-red-500"> ✗</span>
                                    <p className="text-sm leading-relaxed text-gray-700">{item}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </div>
    );
};

export default StrengthsAndWeakness;
